import { CONFIGURATION_TYPES, Palette, ThemeConfiguration } from 'mm-theme-configuration';
import { PaletteManager } from './paletteManager';
import { translate } from './themeConfigurationTranslator';

export class ThemeManager {
  paletteManager: PaletteManager;

  themeConfiguration: ThemeConfiguration;

  constructor(palette: Palette, themeConfiguration: ThemeConfiguration) {
    this.themeConfiguration = themeConfiguration;
    this.paletteManager = new PaletteManager(palette);
  }

  instructions = {
    [CONFIGURATION_TYPES.COLOR]: (key: string) => this.paletteManager.getColorByKey(key),
    [CONFIGURATION_TYPES.SURFACE]: (key:string) => this.paletteManager.getSurfaceStyleByKey(key),
    [CONFIGURATION_TYPES.TYPOGRAPHY]: (key:string) => this.paletteManager.getTypographyStyleByKey(key),
    [CONFIGURATION_TYPES.VR_LINEHEIGHT]: (key:string) => this.paletteManager.getVrLineHeight(key),
  };

  getConfiguration() {
    return translate(this.instructions, this.themeConfiguration);
  }
}
